<div id="reviews">
    <h1>Reviews</h1>

    <div class="all">
        <div class="review">
            <div class="content">
                <p>"Learning Python with him is a great experience. He has complete knowledge about what he is teaching. He is teaching Python with flavor of my needs. That is what I wanted. If i describe in 3 words: A good teacher, Knowledgeable, A good human being. Thumbs up for him. "</p>
            </div>
            <div class="from">
                <p class="person">Karthik Trivedi</p>
                <p class="for">Attended python coaching <a href="https://www.urbanpro.com/adityashankar#reviews">(proof of review)</a></p>
            </div>
        </div>
    
        <div class="review r2">
            <div class="content">
                <p>"Taught every topic in a very interesting manner. His teaching was very clear, detailed and easy to absorb. He was a constant motivator, a great teacher and am amazing person! Would definitely love to learn more and more from him"</p>
            </div>
            <div class="from">
                <p class="person">Yashasvi Kotra</p>
                <p class="for">Attended Python, JavaScript and <br>HTML Basics training</p>
            </div>
        </div>
    </div>
</div>

<style>
    #reviews{
        margin-top: 140px;
        font-family: 'Josefin Sans', sans-serif;
        width: 100%;
    }

    .all{
        max-width: max-content;
        margin: 230px auto;
        display : flex;
        flex-wrap: wrap;
        justify-content: center;
    }

    .review{
        max-width: max-content;
        background: coral;
        padding: 30px;
        margin: 10px 20px;
    }

    .review.r2{
        background: rgb(250, 233, 0);
        color: blue;
    }

    .content{
        font-size: 1.3rem;
        max-width: 500px;
    }

    .from{
        margin-top: 30px;
    }

    .from .person{
        font-size: 1.7rem;
    }
    h1{
        font-size: 3rem;
    }

    @media(max-width:1250px){
        .all{
            margin: 50px auto;
        }
    }
</style>